import React, { useState } from "react";
import { Shield, Tv, Wrench, BatteryFull, CheckCircle2, Plus } from "lucide-react";
import { useLang } from "@/App";

const ICONS = [Shield, Tv, Wrench, BatteryFull];

export default function Accessories() {
  const { t } = useLang();
  const a = t.accessories;
  const [openIdx, setOpenIdx] = useState(null);
  return (
    <section id="accesorios" className="py-20 md:py-28 bg-white" data-testid="accessories-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-widest text-sky-700">{a.kicker}</p>
          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold tracking-tight text-blue-950 leading-[1.1]">
            {a.title}
          </h2>
          <p className="mt-5 text-lg text-slate-700 leading-relaxed">{a.subtitle}</p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {a.categories.map((cat, i) => {
            const Icon = ICONS[i] || Shield;
            const isOpen = openIdx === i;
            return (
              <article
                key={i}
                onClick={() => setOpenIdx(isOpen ? null : i)}
                className="group cursor-pointer rounded-2xl border border-slate-200 bg-slate-50 p-7 hover:bg-white hover:shadow-lg transition-all flex flex-col"
                data-testid={`accessory-cat-${i}`}
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="grid place-items-center w-14 h-14 rounded-2xl bg-blue-900 text-white">
                    <Icon className="w-7 h-7" />
                  </div>
                  <Plus className={`w-5 h-5 text-slate-400 transition-transform ${isOpen ? "rotate-45" : "group-hover:rotate-45"}`} />
                </div>
                <h3 className="mt-6 text-xl md:text-2xl font-bold text-slate-900 leading-tight">
                  {cat.title}
                </h3>
                <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-96 opacity-100 mt-4" : "max-h-0 opacity-0 group-hover:max-h-96 group-hover:opacity-100 group-hover:mt-4"}`}>
                  <ul className="space-y-2.5 flex-1">
                    {cat.items.map((it, j) => (
                      <li key={j} className="flex items-start gap-2.5">
                        <CheckCircle2 className="w-4 h-4 mt-1 text-sky-600 shrink-0" />
                        <span className="text-sm md:text-base text-slate-600 leading-relaxed">
                          {it}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            );
          })}
        </div>

        <p
          className="mt-10 text-center text-base md:text-lg text-slate-700 italic"
          data-testid="accessories-footer"
        >
          {a.footer}
        </p>
      </div>
    </section>
  );
}
